var _path, _path2, _circle, _path3, _circle2, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArea = (_ref, ref) => {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.84 50.08",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.77,39.07,30.86,10.44M11.39,45.08H43.5M24.56,10.46,8.35,39.32",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.12,5.83A5.52,5.52,0,1,1,27.6.31,5.52,5.52,0,0,1,33.12,5.83Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6,
    cy: 30.57,
    r: 5.52,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.34,44.26a5.51,5.51,0,1,1-3-4.92A5.51,5.51,0,0,1,11.34,44.26Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.02,
    cy: 44.26,
    r: 5.52,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.57,
    y1: 41.34,
    x2: 22.72,
    y2: 33.43,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 44.26,
    y1: 41.4,
    x2: 32.31,
    y2: 33.61,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 27.6,
    y1: 11.34,
    x2: 27.6,
    y2: 25.06,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArea);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/area.a66d8190530c7e734473d7c793507646.svg";